// Port of api/fuel/app/classes/model/platform/voting/feature.php
import Model from 'offline/stream/model/base'

export default Model.extend({
	table: 'platform_voting_feature',
	prefix: 'feature',
	key: 'feature_id',
	fields: {
		feature_id: Model.SCHEMA_KEY,
		feature_name: Model.SCHEMA_TEXT,
		feature_description: Model.SCHEMA_TEXT,
		feature_status: Model.SCHEMA_NUMBER,
		feature_date_added: Model.SCHEMA_NUMBER,
		feature_date_won: Model.SCHEMA_NUMBER,
		feature_date_removed: Model.SCHEMA_NUMBER
	}
})
